import { CurrentUserModel } from './../../../models/account-ledger.model';
import { AuthService } from './../../../services/auth.service';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
// tslint:disable-next-line:import-blacklist
import { Subject, Subscription } from 'rxjs';
import { CheckOutService } from '../../../services/checkout.service';
import { ShippingAddressViewModel } from '../../../models/shopping-cart.model';
import { FreightViewModel, DickerTransportZonesDetail, CheckoutViewModel, CheckoutStatusModel, Carrier, CartBillingAndShippings } from '../../../models/check-out.model';
import { CommonService } from '../../../services/common.service';
import { ApiResponse } from '../../../models/api-response.model';
import { AirFreightTermsComponent } from '../../../popup-collection/air-freight-terms/air-freight-terms.component';
import { map, switchMap, takeUntil } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';


@Component({
    selector: 'app-freight-ship-method',
    templateUrl: './freight-ship-method.component.html',
    styleUrls: ['./freight-ship-method.component.css']
})
export class FreightShipMethodComponent implements OnInit, OnDestroy {

    title = 'Freight & Shipping Method';
    setFullWindow = false;
    loadContent = false;
    cartId: string;
    cartName: string;
    currentUserModel: CurrentUserModel;
    subscriptionRoute: Subscription;
    shippingAddressModel: ShippingAddressViewModel;
    freightModel: FreightViewModel;
    zoneDetailModel: DickerTransportZonesDetail[];
    shippingInstructions = '';
    carrierCode = '';
    serviceName = '';
    carrierServiceCode = '';
    shippingMethod = 'shippingMethod';
    roadRadioValue = '';
    airRadioValue = '';
    billing: CartBillingAndShippings;
    airTermsAcceptance = false;
    freightCharge: number;
    checkoutViewModel: CheckoutViewModel;
    showShipMethod = false;
    isQuoteRequired = false;
    standardRoadFreightSelected = false;
    isTenantRequired = true;
    checkoutStatus: CheckoutStatusModel;
    carriers: Carrier[] = [];
    warning = '';
    freightTime: number;
    ngUnsubscribe: Subject<void> = new Subject<void>();
    serial: string;
    
    backto: string;

    quoteId: string;

    skipEndUserStep: boolean;
    constructor(
        private router: Router
        , private activatedRoute: ActivatedRoute
        , private checkOutService: CheckOutService
        , private commonService: CommonService
        , private authService: AuthService
        , private dialog: MatDialog) { }

    ngOnInit() {
        // const date = new Date();
        // this.freightTime = date.getHours();
        $('.page-contents').animate({
            scrollLeft: ($('#levelOne').outerWidth() + $('#cart-summary').outerWidth())
        }, 400);
        this.loadContent = false;
        this.activatedRoute.parent.url.subscribe(value => {
            this.cartId = value.length > 1 ? value[1].path : '';
            this.cartName = value.length > 1 ? value[2].path : '';
        },
            (error: any) => {
                console.error(error);
                this.loadContent = true;
            });
        this.checkOutService.passModelWatch.subscribe((res: ShippingAddressViewModel) => {
            this.shippingAddressModel = res;
        },
            (error: any) => {
                console.error(error);
                this.loadContent = true;
            });

        this.authService.getLoginInfo().subscribe((model: CurrentUserModel) => {
            this.currentUserModel = model;
        });

        // this.activatedRoute.parent.parent.paramMap.takeUntil(this.ngUnsubscribe).subscribe((params) => {
        //     this.serial = params.get('serial');
        // })

        this.activatedRoute.parent.parent.parent.paramMap.pipe(
            switchMap((params) => {
                return this.activatedRoute.parent.parent.paramMap.pipe(
                    map((param) => {
                        return {
                            quoteId: params.get('sku'),
                            serial: param.get('serial'),
                        }
                    })
                )
            })
        ).pipe(takeUntil(this.ngUnsubscribe)).subscribe((res) => {
            this.quoteId = res.quoteId;
            this.serial = res.serial;
            if (this.quoteId) {
                this.backto = 'quote';
            } else if (this.serial) {
                this.backto = 'renewal';
            } else {
                this.backto = 'cart';
            }
        })

        this.checkOutService.GetFreight(this.cartId).subscribe((fm: FreightViewModel) => {
            this.freightModel = fm;           
            this.isQuoteRequired = this.freightModel.isQuoteRequired;           
            if (this.freightModel.country && this.freightModel.country.toUpperCase() === 'NZ') {
                if (this.freightModel.freeFreightPromo === '1') {
                    this.freightCharge = 0;
                } else if (this.freightModel.freightCharge) {
                    this.freightCharge = this.freightModel.freightCharge;
                } else if (!this.freightModel.freightCharge) {
                    this.freightCharge = 0;
                }
            } else {
                if (this.freightModel.freightCharge) {
                    this.freightCharge = this.freightModel.freightCharge;
                }
            }
            if (this.freightModel.shippingInstructions) {
                this.shippingInstructions = this.freightModel.shippingInstructions;
            }
            if (this.freightModel.freightCost && this.freightModel.freightCost.carriers.length) {
                this.carriers = this.freightModel.freightCost.carriers;
                if (this.carriers.length === 1 && this.carriers[0].serviceCode === 'MANUAL') {
                    this.isQuoteRequired = true;
                }
            } else {
                this.isQuoteRequired = true; 
            }
            if (this.freightModel.freightCost && this.freightModel.freightCost.warnings.length > 0) {
                this.warning = this.freightModel.freightCost.warnings[0];
            }                    
         

            this.checkOutService.GetZoneInfo(this.freightModel.zoneID).subscribe((zoneDetail: DickerTransportZonesDetail[]) => {
                this.zoneDetailModel = zoneDetail;
                this.loadContent = true;
            },
                (error: any) => {
                    console.error(error);
                    this.loadContent = true;
                });
        },
            (error: any) => {
                console.error(error);
                this.loadContent = true;
            });

        this.checkOutService.currentCheckoutViewModel.pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: CheckoutViewModel) => {
            this.checkoutViewModel = res;
        });

        // this.checkOutService.CartCheckout(toNumber(this.cartId)).subscribe((res: CheckoutViewModel) => {
        //     this.checkoutViewModel = res;
        // },
        //     (error: any) => {
        //         console.error(error);
        //         this.loadContent = true;
        //     });


        const isAutoPilotTenantRequired = localStorage.getItem('autoPilotTenant');
        if (isAutoPilotTenantRequired) {
            this.isTenantRequired = isAutoPilotTenantRequired === 'YES' ? true : false;
        }

        this.checkOutService.skipEndUserStep$.pipe(takeUntil(this.ngUnsubscribe)).subscribe((skip: boolean) => {
            this.skipEndUserStep = skip;
        });
    }

    chooseFreightCarrier(carrier: Carrier): void {
        this.shippingMethod = carrier.serviceCode;
        this.freightCharge = carrier.calculated_Price_Ex_GST;
        this.carrierCode = carrier.carrierCode;
        this.serviceName = carrier.serviceName;
        this.carrierServiceCode = carrier.carrierServiceCode;
    }

    SubmitFreight(): void {
        if (this.isQuoteRequired) {
            // NZ site is not using donation page
            // if (this.currentUserModel.isAU) {
            //     this.router.navigate(['donation'], { relativeTo: this.activatedRoute.parent });
            // } else {
                this.router.navigate(['payment-method'], { relativeTo: this.activatedRoute.parent });
            // }
            return;
        }
        // let aestTime = new Date().toLocaleString("en-US", {timeZone: "Australia/Sydney"});
        // let shippingTime = new Date(aestTime).getHours();
        // console.log(shippingTime);
        if (this.shippingMethod === 'PI' || this.shippingMethod === 'PP' ||  this.shippingMethod === 'ON') {

        // if (this.shippingMethod === 'PRM' || this.shippingMethod === 'FPP' || this.shippingMethod === 'PIP' || this.shippingMethod === 'ON') {

            const date = new Date();

            this.freightTime = date.getHours();

            if (this.freightTime >= 14) {
                const dialogRef = this.dialog.open(AirFreightTermsComponent, {
                    width: '500px'
                });
                dialogRef.afterClosed().subscribe(result => {
                    if (result) {
                        this.billing = {
                            shippingInstructions: this.shippingInstructions,
                            willBeCollected: 'Air',
                            airTerms: '',
                            freightCharge: this.freightCharge,
                            freightMethod: `${this.shippingMethod}:${this.carrierCode}:${this.serviceName}`,                           
                        };
                        this.loadContent = false;                       
                        this.checkOutService.UpdateFreight(this.cartId, this.billing).subscribe((res: ApiResponse) => {
                            if (res && res.status) {
                                // NZ site is not using donation page
                                this.loadContent = true;
                                // if (this.currentUserModel.isAU) {
                                //     this.router.navigate(['donation'], { relativeTo: this.activatedRoute.parent });
                                // } else {
                                    this.router.navigate(['payment-method'], { relativeTo: this.activatedRoute.parent });
                                // }
                            } else {
                                this.commonService.showError('.text-initial', 'Oops, something didn\'t go well, please contact Dicker Data', 'right');
                            }
                        },
                            (error: any) => {
                                console.error(error);
                                this.loadContent = true;
                            });
                    }
                });
            } else {
                this.billing = {
                    shippingInstructions: this.shippingInstructions,
                    willBeCollected: 'Air',
                    airTerms: 'No',
                    freightCharge: this.freightCharge,
                    freightMethod: `${this.shippingMethod}:${this.carrierCode}:${this.serviceName}`,
                };
                this.loadContent = false;
                this.checkOutService.UpdateFreight(this.cartId, this.billing).subscribe((res: ApiResponse) => {
                    if (res && res.status) {
                        // NZ site is not using donation page
                        this.loadContent = true;
                        // if (this.currentUserModel.isAU) {
                        //     this.router.navigate(['donation'], { relativeTo: this.activatedRoute.parent });
                        // } else {
                            this.router.navigate(['payment-method'], { relativeTo: this.activatedRoute.parent });
                        // }
                    } else {
                        this.commonService.showError('.text-initial', 'Oops, something didn\'t go well, please contact Dicker Data', 'right');
                    }
                },
                    (error: any) => {
                        console.error(error);
                        this.loadContent = true;
                    });
            }
        } else {
            // if (this.shippingMethod === 'EXP' || this.shippingMethod === 'RET' || this.shippingMethod === 'RE2' || this.shippingMethod === 'ROAD' || this.shippingMethod === 'E')
            if (this.shippingMethod == 'shippingMethod' || !this.shippingMethod) {
                this.commonService.showError('#next-button', 'Please select a shipping method', 'right');
                return;
            }

            this.billing = {
                shippingInstructions: this.shippingInstructions,
                willBeCollected: 'No',
                airTerms: 'No',
                freightCharge: this.freightCharge,
                freightMethod: `${this.shippingMethod}:${this.carrierCode}:${this.serviceName}`,              
            };
            this.loadContent = false;
            this.checkOutService.UpdateFreight(this.cartId, this.billing).subscribe((res: ApiResponse) => {
                if (res && res.status) {
                    // NZ site is not using donation page
                    this.loadContent = true;
                    // if (this.currentUserModel.isAU) {
                    //     this.router.navigate(['donation'], { relativeTo: this.activatedRoute.parent });
                    // } else {
                        this.router.navigate(['payment-method'], { relativeTo: this.activatedRoute.parent });
                    // }
                } else {
                    this.commonService.showError('.text-initial', 'Oops, something didn\'t go well, please contact Dicker Data', 'right');
                }
            },
                (error: any) => {
                    console.error(error);
                    this.loadContent = true;
                    this.commonService.implementToast(error, 'Error');
                });
        } 
        // else {
        //     this.commonService.showError('#next-button', 'Please select a shipping method', 'right');
        // }
    }

    // SubmitFreight(): void {
    //     if (this.airRadioValue) {
    //         if ($('#freightAirPrice').text() == 'Not Available') {
    //             this.freightCharge = 0;
    //         }
    //         else {
    //             this.freightCharge = toNumber(this.airRadioValue);
    //         }
    //         $('#airFreightTerms').foundation('open');
    //     }
    //     else if (this.roadRadioValue) {
    //         if (this.roadRadioValue == 'Free Freight' || this.roadRadioValue == 'Web Free Freight Promotion') {
    //             this.freightCharge = 0;
    //         }
    //         else {
    //             this.freightCharge = toNumber(this.roadRadioValue);
    //         }
    //         this.billing = {
    //             ShippingInstructions: this.shippingInstructions,
    //             WillBeCollected: "No",
    //             AirTerms: "No",
    //             FreightCharge: this.freightCharge
    //         };
    //         this.checkOutService.UpdateFreight(this.cartId, this.billing).subscribe((res: ApiResponse) => {
    //             if(res && res.status){
    //                 this.router.navigate(['payment-method'], { relativeTo: this.activatedRoute.parent });
    //             }else{
    //                 this.commonService.showError(".text-initial", "Oops, something didn't go well, please contact Dicker Data", "right");
    //             }
    //         },
    //             (error: any) => {
    //                 console.error(error);
    //                 this.loadContent = true;
    //             });
    //     }
    //     else {
    //         this.commonService.showError("#next-button", "Please select a shipping method", "right");
    //     }
    // }

    goBackFreight(): void {
        if (this.checkoutViewModel.tenantDetailsRequired === 'YES' && this.isTenantRequired) {
            this.router.navigate(['tenant'], { relativeTo: this.activatedRoute.parent });
        } else if (this.checkoutViewModel.firstStep === 'NOENDUSER' || this.skipEndUserStep) {
            this.router.navigate(['ship-address'], { relativeTo: this.activatedRoute.parent });
        } else {
            this.router.navigate(['end-user'], { relativeTo: this.activatedRoute.parent });
        }
    }

    onLoading(currentLoadingStatus: boolean) {
        this.loadContent = !currentLoadingStatus;
    }
    backtoCart() {
        this.checkOutService.monitorShowCartSummary('show');
        this.router.navigateByUrl(`/myCarts/cart/${this.cartId}/${this.cartName}`);
    }

    backtoRenewals() {
        this.router.navigate(['.'],{relativeTo:this.activatedRoute.parent.parent});
        // this.router.navigateByUrl(`manageRenewalsNew/renewalDetails/${this.serial}`);
    }


    backtoQuotes() {
        this.router.navigate(['.'], { relativeTo: this.activatedRoute.parent.parent });
        $('.combination-loader').animate(
            { scrollLeft: (250 + $('#price-list-detail').width()) }, 100)

    }


    close() {
        // this.checkoutStatus = {
        //     currentStep: '',
        //     firstStep: '',
        //     hasChosenCheckout: false,
        //     collectOrder: false,
        //     tenantDetailsRequired: ''
        // };
        // this.checkOutService.emitChange(this.checkoutStatus);
        // this.router.navigateByUrl(`/myCarts/cart/${this.cartId}/${this.cartName}`);
        this.router.navigate(['../'], { relativeTo: this.activatedRoute });
    }

    ngOnDestroy(): void {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }
}
